import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './ARSTimeLineIconSmall.css';

const KINDS = {
  fill: 'fill',
  outline: 'outline',
  none: 'none',
};

function ARSTimeLineIconSmall({ kind, head, tail, isActive }) {
  const iconClass = classnames(
    'ARSTimeLineIconSmall-icon',
    isActive && kind !== 'critical' && 'ARSTimeLineIconSmall-icon--active',
    head === KINDS.fill
      ? 'ARSTimeLineIconSmall-icon--fill'
      : 'ARSTimeLineIconSmall-icon--outline',
    kind === 'critical' &&
      head === KINDS.fill &&
      'ARSTimeLineIconSmall-icon--critical'
  );
  const lineClass = classnames(
    'ARSTimeLineIconSmall-line',
    tail === KINDS.fill
      ? 'ARSTimeLineIconSmall-line--fill'
      : 'ARSTimeLineIconSmall-line--outline',
    tail === KINDS.none && 'ARSTimeLineIconSmall-line--none',
    kind === 'critical' &&
      tail === KINDS.fill &&
      'ARSTimeLineIconSmall-line--critical'
  );

  return (
    <div className='ARSTimeLineIconSmall'>
      <div className={iconClass} />
      <div className={lineClass}>
        {tail === KINDS.outline &&
          [...Array(10).keys()].map((key) => (
            <div
              key={key}
              className={`ARSTimeLineIconSmall-lineChild--outline ${
                kind === 'critical'
                  ? 'ARSTimeLineIconSmall-lineChild--critical'
                  : ''
              }`}
            />
          ))}
      </div>
    </div>
  );
}

ARSTimeLineIconSmall.propTypes = {
  kind: PropTypes.string,
  head: PropTypes.oneOf(Object.values(KINDS)),
  tail: PropTypes.oneOf(Object.values(KINDS)),
  isActive: PropTypes.bool,
};

// TODO: @Sagar, UI-1019, Need to check this for Icon kind info replacement with AlertInfoFilledSeparateColors regressions
ARSTimeLineIconSmall.defaultProps = {
  kind: 'info',
  head: KINDS.fill,
  tail: KINDS.fill,
  isActive: false,
};

export default ARSTimeLineIconSmall;
